const key = 'optimizely-forced-decisions';

type ForcedDecisions = Record<string, string>;

export function getForceDecisions(name: string): ForcedDecisions {
    const currentDecisions = localStorage.getItem(`${key}-${name}`);
    return currentDecisions ? JSON.parse(currentDecisions) : {};
}

export function persistForceDecision(name: string) {
    return (featureFlag: string, value: string) => {
        const decisions = getForceDecisions(name);
        decisions[featureFlag] = value;
        localStorage.setItem(`${key}-${name}`, JSON.stringify(decisions));
    };
}

export function removeForceDecision(name: string) {
    return (featureFlag: string) => {
        const decisions = getForceDecisions(name);
        delete decisions[featureFlag];
        localStorage.setItem(`${key}-${name}`, JSON.stringify(decisions));
    };
}

export function resetDecisions(name: string) {
    return () => {
        localStorage.setItem(`${key}-${name}`, JSON.stringify({}));
    };
}
